<template>
    <div>
        <el-form  ref="ruleForm"  label-width="125px" size="mini">
            <div class="flex jcsb">
                <el-form-item   label="业务ID"class="flex1">
                    <span>{{formData.vc_ywid}}</span>
                </el-form-item>
                <el-form-item   label="方法名"class="flex1">
                    <span>{{formData.vc_methodName}}</span>
                </el-form-item>
            </div>
            <div class="flex jcsb">
                <el-form-item label="来源" class="flex1">
                    <span>{{formData.vc_caller_system}}</span>
                </el-form-item>
                <el-form-item label="调用方向"class="flex1">
                    <span v-if="formData.i_direction==0"  class="dib yellow">OA调用第三方</span>
                    <span v-if="formData.i_direction==1"  class="dib green">第三方调用OA</span>
                </el-form-item>
            </div>
            <el-form-item  label="参数">
                <span class="json_data">{{formData.vc_methodParameters}}</span>
            </el-form-item>
            <el-form-item   label="返回信息">
                <span>{{formData.vc_responseMessage}}</span>
            </el-form-item>
            <div class="flex jcsb">
                <el-form-item  label="状态" class="flex1">
                    <span v-if="formData.i_status==0"  class="dib yellow">处理中</span>
                    <span v-if="formData.i_status==1"  class="dib green">成功</span>
                    <span v-if="formData.i_status==-1" class="dib red">失败</span>
                    <span v-if="formData.i_status==2" class="dib yellow">已重发</span>
                </el-form-item>
                <el-form-item   label="重试次数" class="flex1">
                    <span>{{formData.i_retryCount}}</span>
                </el-form-item>
            </div>
            <div class="flex jcsb">
                <el-form-item   label="创建时间" class="flex1">
                    <span>{{formData.dt_createtime}}</span>
                </el-form-item>
                <el-form-item  label="最后一次重试时间" class="flex1">
                    <span>{{formData.dt_last_retry_time}}</span>
                </el-form-item>
            </div>
        </el-form>
        <div class="center" >
            <el-button type="primary" size="mini" @click="close">取消</el-button>
        </div>

    </div>
</template>

<script>
    import * as API from "../api";
    import {mapActions} from "vuex";
    export default {
        name: 'BusinessEntry',
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data(){
            return{
                formData:{},
               
            }
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
            data(){
                // console.log(this.data,'data');
                this.formData=this.data;
            },
            immediate:true,
            deep:true,
        },
        activated(){
            this.onResize();
        },
        mounted(){
            this.$nextTick(()=>{
                this.onResize();
            })
            // console.log(this.data,'data');

            this.formData=this.data;

            // this.getMqDetail()

        },
        methods:{
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-178

            },
            //消费服务下拉查询
            // async getMqDetail() {
            //     let params = {
            //         i_id:this.data.i_id
            //     }
            //     let res = await API.getMqDetail(params);
            //     if (res.code == 1) {
            //         this.formData=res.data
            //         // console.log(res)
            //     } else if (res.code == -2) {
            //         this.$router.push('/login');
            //         this.$message.error(res.message);
            //     } else {
            //         this.$message.error(res.message);
            //     }
            // },
             close(){
                 this.$emit('close')
            },
        }
    }
</script>
<style lang="scss" scoped>
    .flex{
        display: flex;
    }
    .flex1{
        flex: 1;
    }
    .jcsb{
        justify-content: space-between;
    }
    /deep/{
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
        }
        .el-textarea__inner{
            height: 100px !important;
            color: #000000 !important;
            /*font-weight: 600 !important;*/
            font-size: inherit !important;
        }
        .el-form-item__error{
            left: 50% !important;
        }
    }
    .lable-width{
        text-align: center;
    }
    .slable-width{

    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 18.571rem;
    }
    .sinput-width{
        width: 150px;
        margin-left: 28px;
    }
    .center{
        text-align: center;
    }
    .red{
        color: red;
    }
    .green{
        color: green;
    }
    .yellow{
        color: #ffbe06;
    }
    .json_data{
        max-height: 230px;
        overflow-y: auto;
        display: inline-block;
    }
</style>